export default "__VITE_ASSET__DSyPUg9L__"